import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ScheduleIcon from "@material-ui/icons/Schedule";
import SpeakerIcon from "@material-ui/icons/Speaker";
import UnsubscribeIcon from "@material-ui/icons/Unsubscribe";
import TrackChangesIcon from "@material-ui/icons/TrackChanges";
import CategoryIcon from "@material-ui/icons/Category";
import BookIcon from "@material-ui/icons/Book";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import LanguageIcon from "@material-ui/icons/Language";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { Link, useLocation } from "react-router-dom";
import ScatterPlotIcon from "@material-ui/icons/ScatterPlot";
import PersonIcon from "@material-ui/icons/Person";
import GroupIcon from "@material-ui/icons/Group";
import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";
import InfoIcon from "@material-ui/icons/Info";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";
import ForumIcon from "@material-ui/icons/Forum";
import DvrIcon from "@material-ui/icons/Dvr";
import "../include/Sidenav.css";
import registereduser from "../images/registereduser.png";

const useStyles = makeStyles((theme) =>
  createStyles({
    nested: {
      paddingLeft: theme.spacing(3),
    },
    activeItem: {
      backgroundColor: "cornflowerblue",
      "& .MuiListItemText-primary": {
        color: "white",
      },
      "&:hover": {
        backgroundColor: "cornflowerblue", // Change to a darker shade on hover
      },
    },
  })
);

export default function Sidenav() {
  const classes = useStyles();
  const location = useLocation();

  const isAdmin = localStorage.getItem('userData');
  const userData = JSON.parse(isAdmin);

  const [open, setOpen] = React.useState(false);
  const [userOpen, setUserOpen] = React.useState(false);
  const [aboutOpen, setAboutOpen] = React.useState(false);
  const [resourcesOpen, setResourcesOpen] = React.useState(false);
  const [tsOpen, setTSOpen] = React.useState(false);
  const [webinarOpen, setWebinarOpen] = React.useState(false);
  const isActive = (path) => location.pathname === path;
  const handleClick = () => {
    setOpen(!open);
  };

  const handleUserClick = () => {
    setUserOpen(!userOpen);
  };

  const aboutHandleClick = () => {
    setAboutOpen(!aboutOpen);
  };
  const resourcesHandleClick = () => {
    setResourcesOpen(!resourcesOpen);
  };

  const tsHandleClick = () => {
    setTSOpen(!tsOpen);
  };

  const handleWebinarClick = () => {
    setWebinarOpen(!webinarOpen);
  };

  // Disable /dashboard link if already on /dashboard path
  const isDashboardPage = location.pathname === "/dashboard";

  return (
    <List className="sideNavBox">
      {isDashboardPage ? (
        <ListItem button className={isActive("/dashboard") ? classes.activeItem : ""}>
          <ListItemIcon>
            <img src={process.env.PUBLIC_URL + "/images/dashboard.png"} alt="Dashboard" />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
      ) : (
        <Link to="/dashboard">
          <ListItem button className={isActive("/dashboard") ? classes.activeItem : ""}>
            <ListItemIcon>
              <img src={process.env.PUBLIC_URL + "/images/dashboard.png"} alt="Dashboard" />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
        </Link>
      )}

      <Link to="/user-count">
        <ListItem button className={isActive("/user-count") ? classes.activeItem : ""}>
          <ListItemIcon>
            {/* <DvrIcon /> */}
            <img src={registereduser} />
          </ListItemIcon>
          <ListItemText primary="User Information " />
        </ListItem>
      </Link>

      <Link to="/training-menu">
        <ListItem button className={isActive("/training-menu") ? classes.activeItem : ""} onClick={tsHandleClick}>
          <ListItemIcon>
            {/* <InfoIcon /> */}
            <img
              src={process.env.PUBLIC_URL + "/images/training-schedule.png"}
            />
          </ListItemIcon>
          <ListItemText primary="Training" />
        </ListItem>
      </Link>
      {/* <Collapse in={tsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/speaker">
                <SpeakerIcon />
              </Link>
            </ListItemIcon>
            <Link to="/speaker">
              <ListItemText primary="Speaker" />
            </Link>
          </ListItem>

          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/training-schedule">
                <ScheduleIcon />
              </Link>
            </ListItemIcon>
            <Link to="/training-schedule">
              <ListItemText primary="Training Schedule" />
            </Link>
          </ListItem>
        </List>
      </Collapse> */}
      <Link to="/announcement-news">
        <ListItem button className={isActive("/announcement-news") ? classes.activeItem : ""}>
          <ListItemIcon>
            {/* <AnnouncementIcon /> */}
            <img src={process.env.PUBLIC_URL + "/images/news.png"} />
          </ListItemIcon>
          <ListItemText primary="Govt Circulars/GR" />
        </ListItem>
      </Link>

      <Link to="/article">
        <ListItem button className={isActive("/article") ? classes.activeItem : ""}>
          <ListItemIcon>
            {/* <BookIcon /> */}
            <img src={process.env.PUBLIC_URL + "/images/blog.png"} />
          </ListItemIcon>
          <ListItemText primary="Articles" />
        </ListItem>
      </Link>

      <Link to="/faq">
        <ListItem button className={isActive("/faq") ? classes.activeItem : ""}>
          <ListItemIcon>
            {/* <LiveHelpIcon /> */}
            <img src={process.env.PUBLIC_URL + "/images/faq.png"} />
          </ListItemIcon>
          <ListItemText primary="FAQ's" />
        </ListItem>
      </Link>

      <Link to="/testimonials">
        <ListItem button className={isActive("/testimonials") ? classes.activeItem : ""}>
          <ListItemIcon>
            {/* <DvrIcon /> */}
            <img src={process.env.PUBLIC_URL + "/images/testimonials.png"} />
          </ListItemIcon>
          <ListItemText primary="Testimonials " />
        </ListItem>
      </Link>

      <Link to="/contact-us-enquiry">
        <ListItem button className={isActive("/contact-us-enquiry") ? classes.activeItem : ""}>
          <ListItemIcon>
            <img src={process.env.PUBLIC_URL + "/images/enquiry.png"} />
          </ListItemIcon>
          <ListItemText primary="Contact Us" />
        </ListItem>
      </Link>
      <Link to="/banner">
        <ListItem button className={isActive("/banner") ? classes.activeItem : ""}>
          <ListItemIcon>
            <img src={process.env.PUBLIC_URL + "/images/enquiry.png"} />
          </ListItemIcon>
          <ListItemText primary="Banner" />
        </ListItem>
      </Link>

      {/* <Collapse in={userOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/get-in-touch">
                <TrackChangesIcon />
              </Link>
            </ListItemIcon>
            <Link to="/get-in-touch">
              <ListItemText primary="Footer Enquiry" />
            </Link>
          </ListItem>

          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/contact-us-enquiry">
                <UnsubscribeIcon />
              </Link>
            </ListItemIcon>
            <Link to="/contact-us-enquiry">
              <ListItemText primary="Contact Us Enquiry" />
            </Link>
          </ListItem>

          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/help-us-to-improve">
                <UnsubscribeIcon />
              </Link>
            </ListItemIcon>
            <Link to="/help-us-to-improve">
              <ListItemText primary="Help Us To Improve" />
            </Link>
          </ListItem>
        </List>
      </Collapse> */}
      <ListItem button className={(isActive("/team") || isActive("/other-activities")) ? classes.activeItem : ""} onClick={aboutHandleClick}>
        <ListItemIcon>
          {/* <InfoIcon /> */}
          <img src={process.env.PUBLIC_URL + "/images/about-us.png"} />
        </ListItemIcon>
        <ListItemText primary="About Us" />
        {aboutOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={aboutOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link to="/team">
            <ListItem button className={isActive("/team") ? classes.activeItem + " " + classes.activeItem : classes.nested}>
              <ListItemIcon>
                <GroupIcon />
              </ListItemIcon>
              <ListItemText primary="Our Team" />
            </ListItem>
          </Link>

          <Link to="/other-activities">
            <ListItem button className={isActive("/other-activities") ? classes.activeItem + " " + classes.activeItem : classes.nested}>
              <ListItemIcon>
                <CategoryIcon />
              </ListItemIcon>
              <ListItemText primary="Other Activities" />
            </ListItem>
          </Link>
        </List>
      </Collapse>

      <Link to="/tr-for-teacher">
        <ListItem button className={isActive("/tr-for-teacher") ? classes.activeItem : ""}>
          <ListItemIcon>
            {/* <Link to="/teacher"> */}
            {/* <DeveloperBoardIcon /> */}
            <img src={process.env.PUBLIC_URL + "/images/teachers.png"} />
            {/* </Link> */}
          </ListItemIcon>
          <ListItemText primary="Tr for Teacher" />
        </ListItem>
      </Link>

      {/* <ListItem button onClick={resourcesHandleClick}>
        <ListItemIcon>
        
          <img src={process.env.PUBLIC_URL + "/images/resources.png"} />
        </ListItemIcon>
        <ListItemText primary="Glimpses" />
        {resourcesOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={resourcesOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/video">
                <VideoLibraryIcon />
              </Link>
            </ListItemIcon>
            <Link to="/video">
              <ListItemText primary="Video" />
            </Link>
          </ListItem>

          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/video-category">
                <CategoryIcon />
              </Link>
            </ListItemIcon>
            <Link to="/video-category">
              <ListItemText primary="Video Category" />
            </Link>
          </ListItem>

          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/article">
                <AssignmentIcon />
              </Link>
            </ListItemIcon>
            <Link to="/article">
              <ListItemText primary="Article" />
            </Link>
          </ListItem>

          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/article-category">
                <CategoryIcon />
              </Link>
            </ListItemIcon>
            <Link to="/article-category">
              <ListItemText primary="Article Category" />
            </Link>
          </ListItem>
        </List>
      </Collapse> */}

      {/*<ListItem button>
      <ListItemIcon>
      <Link to='/article'><AssignmentIcon /></Link>
      </ListItemIcon>
      <Link to='/article'><ListItemText primary="Article" /></Link>
    </ListItem>

    <ListItem button>
      <ListItemIcon>
      <Link to='/video'><VideoLibraryIcon /></Link> 
      </ListItemIcon>
      <Link to='/video'><ListItemText primary="Video" /></Link>
    </ListItem>*/}

      {/*<ListItem button>
      <ListItemIcon>
      <Link to='/training-schedule'><ScheduleIcon /></Link>
      </ListItemIcon>
      <Link to='/training-schedule'><ListItemText primary="Training Schedule" /></Link>
    </ListItem>*/}

      {/* <ListItem button onClick={handleClick}>
        <ListItemIcon>
       

          <img src={process.env.PUBLIC_URL + "/images/discussion-board.png"} />
        </ListItemIcon>
        <ListItemText primary="Discussion Board" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/category">
                <CategoryIcon />
              </Link>
            </ListItemIcon>
            <Link to="/category">
              <ListItemText primary="Categories" />
            </Link>
          </ListItem>

          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/forum">
                <ForumIcon />
              </Link>
            </ListItemIcon>
            <Link to="/forum">
              <ListItemText primary="Forum" />
            </Link>
          </ListItem>
        </List>
      </Collapse> */}

      <Link to="/menu">
        <ListItem button className={isActive("/menu") ? classes.activeItem : ""}>
          <ListItemIcon>
            {/* <DashboardIcon /> */}
            <img src={process.env.PUBLIC_URL + "/images/menu.png"} />
          </ListItemIcon>
          <ListItemText primary="Menu" />
        </ListItem>
      </Link>

      {/* <ListItem button onClick={handleWebinarClick}>
        <ListItemIcon>
         
          <img src={process.env.PUBLIC_URL + "/images/webinar.png"} />
        </ListItemIcon>
        <ListItemText primary="Webinar" />
        {userOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={webinarOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <Link to="/webinar">
                <LanguageIcon />
              </Link>
            </ListItemIcon>
            <Link to="/webinar">
              <ListItemText primary="Webinar" />
            </Link>
          </ListItem>
        
        </List>
      </Collapse> */}

      {/* <ListItem button>
        <ListItemIcon>
          <Link to="/subscriber">
         
            <img src={process.env.PUBLIC_URL + "/images/subscribers.png"} />
          </Link>
        </ListItemIcon>
        <Link to="/subscriber">
          <ListItemText primary="Subscriber" />
        </Link>
      </ListItem> */}

      {/* 
      <ListItem button>
        <ListItemIcon>
          <Link to="/school-college">
            <LanguageIcon />
          </Link>
        </ListItemIcon>
        <Link to="/school-college">
          <ListItemText primary="School/College" />
        </Link>
      </ListItem> */}

      {(userData && userData.admin_role === 'superadmin') &&
        <>
          <Link to="/create-admin">
            <ListItem button className={(isActive("/create-admin") || isActive("/edit-admin")) ? classes.activeItem : ""}>
              <ListItemIcon>
                <img className="sidenav-icon" src={process.env.PUBLIC_URL + "/images/admin.png"} alt="admins" />
              </ListItemIcon>
              <ListItemText primary="Create Admin" />
            </ListItem>
          </Link>

          <Link to="/view-admins">
            <ListItem button className={isActive("/view-admins") ? classes.activeItem : ""}>
              <ListItemIcon>
                <img className="sidenav-icon" src={process.env.PUBLIC_URL + "/images/group.png"} alt="group" />
              </ListItemIcon>
              <ListItemText primary="Admin List" />
            </ListItem>
          </Link>
        </>
      }
    </List>
  );
}
